import React from 'react';

const SystemCard = ({ title, bgColor, color, rows }) => (
  <div style={{ background: bgColor, padding: '1rem', borderRadius: '8px' }}>
    <h3 style={{ fontSize: '0.95rem', fontWeight: '600', color, marginBottom: '0.75rem' }}>{title}</h3>
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem', fontSize: '0.875rem' }}>
      {rows.map((row, i) => (
        <div key={i} style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span style={{ color: '#666' }}>{row.label}</span>
          <span style={{ fontWeight: '600' }}>{row.value}</span>
        </div>
      ))}
    </div>
  </div>
);

const LeadCalculationResults = ({ lead, calcData, hasCostData, formatCurrency, convertToDisplayCurrency, leadCurrency, leadLocale }) => {
  if (!hasCostData) return null;

  const fc = (val) => formatCurrency(convertToDisplayCurrency(val || 0), leadCurrency, leadLocale);

  return (
    <div className="admin-card">
      <h2 style={{ fontSize: '1.25rem', fontWeight: '600', marginBottom: '1.5rem' }}>Berechnungsergebnisse ({leadCurrency})</h2>
      {calcData ? (
        <>
          {/* Kennzahlen */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem', marginBottom: '1.5rem' }}>
            {calcData.demand_kwh != null && (
              <div>
                <label style={{ fontSize: '0.875rem', color: '#666', display: 'block', marginBottom: '0.25rem' }}>Wärmebedarf</label>
                <p style={{ fontWeight: '600' }}>{Math.round(convertToDisplayCurrency(calcData.demand_kwh))} kWh/Jahr</p>
              </div>
            )}
            {calcData.leistungsbedarf != null && (
              <div>
                <label style={{ fontSize: '0.875rem', color: '#666', display: 'block', marginBottom: '0.25rem' }}>Heizleistung Sole-WP</label>
                <p style={{ fontWeight: '600' }}>{Number(calcData.leistungsbedarf).toFixed(1)} kW</p>
              </div>
            )}
            {calcData.bohrmeter != null && (
              <div>
                <label style={{ fontSize: '0.875rem', color: '#666', display: 'block', marginBottom: '0.25rem' }}>Bohrmeter gesamt</label>
                <p style={{ fontWeight: '600' }}>{Math.round(calcData.bohrmeter)} m</p>
              </div>
            )}
          </div>

          {/* Drei Systeme */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1rem', marginBottom: '1rem' }}>
            <SystemCard title="separatus" bgColor="#E8F5E9" color="#1B5E20" rows={[
              { label: 'Investitionskosten', value: fc(calcData.invest_beginn_separatus) },
              { label: 'Vollkosten 25J', value: fc(calcData.vollkosten_separatus) },
              { label: 'Jahreskosten', value: fc(calcData.jahreskosten_separatus) },
            ]} />
            <SystemCard title="Konventionelle Erdwärme" bgColor="#FFF3E0" color="#E65100" rows={[
              { label: 'Investitionskosten', value: fc(calcData.invest_beginn_konventionelle) },
              { label: 'Vollkosten 25J', value: fc(calcData.vollkosten_konventionelle) },
              { label: 'Jahreskosten', value: fc(calcData.jahreskosten_konventionelle) },
            ]} />
            <SystemCard title="Luftwärme" bgColor="#E3F2FD" color="#0D47A1" rows={[
              { label: 'Investitionskosten', value: fc(calcData.invest_beginn_luftwaerme) },
              { label: 'Vollkosten 25J', value: fc(calcData.vollkosten_luftwaerme) },
              { label: 'Jahreskosten', value: fc(calcData.jahreskosten_luftwaerme) },
            ]} />
          </div>

          {/* Einsparung */}
          {calcData.ersparnis_vollkosten != null && (
            <div style={{ background: '#E8F5E9', border: '2px solid #4CAF50', borderRadius: '8px', padding: '1rem', textAlign: 'center' }}>
              <span style={{ fontSize: '0.875rem', color: '#666' }}>Einsparung Vollkosten vs. Luft: </span>
              <span style={{ fontSize: '1.25rem', fontWeight: '700', color: '#1B5E20' }}>{fc(calcData.ersparnis_vollkosten)}</span>
            </div>
          )}
        </>
      ) : (
        /* Legacy format */
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1.5rem' }}>
          <div style={{ background: '#E8F5E9', padding: '1rem', borderRadius: '8px' }}>
            <label style={{ fontSize: '0.875rem', color: '#666', display: 'block', marginBottom: '0.5rem' }}>separatus-System</label>
            <p style={{ fontSize: '1.5rem', fontWeight: '700', color: '#1B5E20' }}>{fc(lead.invest_separatus_eur)}</p>
          </div>
          <div style={{ background: '#FFF3E0', padding: '1rem', borderRadius: '8px' }}>
            <label style={{ fontSize: '0.875rem', color: '#666', display: 'block', marginBottom: '0.5rem' }}>Luftwärmepumpe</label>
            <p style={{ fontSize: '1.5rem', fontWeight: '700', color: '#F57C00' }}>{fc(lead.invest_lwp_eur)}</p>
          </div>
          <div style={{ background: '#E3F2FD', padding: '1rem', borderRadius: '8px' }}>
            <label style={{ fontSize: '0.875rem', color: '#666', display: 'block', marginBottom: '0.5rem' }}>Jährliche Ersparnis</label>
            <p style={{ fontSize: '1.5rem', fontWeight: '700', color: '#1976D2' }}>{fc(lead.annual_savings_eur)}</p>
          </div>
          {lead.amortization_years && (
            <div style={{ background: '#F3E5F5', padding: '1rem', borderRadius: '8px' }}>
              <label style={{ fontSize: '0.875rem', color: '#666', display: 'block', marginBottom: '0.5rem' }}>Amortisation</label>
              <p style={{ fontSize: '1.5rem', fontWeight: '700', color: '#7B1FA2' }}>{lead.amortization_years} Jahre</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default LeadCalculationResults;
